import React from 'react';
import PropTypes from 'prop-types';
import { Container, Label, Input } from './styles';

const Checkbox = ({name, label, checked, onChange, forwardRef, ...props}) => {
  return (
    <Container>
      <Input type="checkbox" name={name} checked={checked} ref={forwardRef} onChange={onChange} {...props} />
      <Label>
        {label}
      </Label>
    </Container>
  )
}

Checkbox.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
}

export default Checkbox;